import React from 'react';
import { IonItem, IonLabel, IonText } from '@ionic/react';
import type { InventoryProductListRowProps } from 'features/shared/inventory/types/InventoryProductListRowProps';
import './InventoryProductListRowMobile.scss';

/**
 * Mobile products-list row (`hk-mobile-digital-inventory-products-list-item`).
 * Same fields/shape as {@link InventoryProductListRowDesktop}.
 */
const InventoryProductListRowMobile: React.FC<InventoryProductListRowProps> = ({
  image,
  title,
  modelDisplay,
  brandDisplay,
  onClick
}) => {
  return (
    <IonItem
      lines="none"
      className="hk-mobile-digital-inventory-products-list-item"
      onClick={onClick}
    >
      <IonLabel className="hk-mobile-digital-inventory-products-list-item-body">
        <div className="hk-mobile-digital-inventory-products-list-item-icon">
          <img src={image} alt="" />
        </div>
        <div className="hk-mobile-digital-inventory-products-list-item-text">
          <IonText className="hk-mobile-digital-inventory-products-list-item-name">
            <p>{title}</p>
          </IonText>
          <div className="hk-mobile-digital-inventory-products-list-item-fields">
            <IonText className="hk-mobile-digital-inventory-products-list-item-field">
              <p>{modelDisplay}</p>
            </IonText>
            <IonText className="hk-mobile-digital-inventory-products-list-item-field">
              <p>{brandDisplay}</p>
            </IonText>
          </div>
        </div>
      </IonLabel>
      <span className="hk-mobile-digital-inventory-products-list-item-marker" />
    </IonItem>
  );
};

export default InventoryProductListRowMobile;
